export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "decryption.worker.a55985a1.js");
}
